import React, { useState } from "react";

import news1 from "../../images/press-releases/news1.jpg";
import news2 from "../../images/press-releases/news2.jpg";
import news3 from "../../images/press-releases/news3.jpg";
import news4 from "../../images/press-releases/news4.jpg";
import news5 from "../../images/press-releases/news5.jpg";
import news6 from "../../images/press-releases/news6.jpg";
import news7 from "../../images/press-releases/news7.jpg";
import news8 from "../../images/press-releases/news8.jpg";
import news9 from "../../images/press-releases/news9.jpg";
import news10 from "../../images/press-releases/news10.jpg";
import news11 from "../../images/press-releases/news11.jpg";
import news12 from "../../images/press-releases/news12.jpg";
import news13 from "../../images/press-releases/news13.jpg";
import news14 from "../../images/press-releases/news14.jpg";  
import news15 from "../../images/press-releases/news15.jpg";
import news16 from "../../images/press-releases/news16.jpg";
import news17 from "../../images/press-releases/news17.jpg";
import news18 from "../../images/press-releases/news18.jpg";
import news19 from "../../images/press-releases/news19.jpg";
import news20 from "../../images/press-releases/news20.jpg";
import news21 from "../../images/press-releases/news21.jpg";
import news22 from "../../images/press-releases/news22.jpg";
import news23 from "../../images/press-releases/news23.jpg";
import news24 from "../../images/press-releases/news24.jpg";
import news25 from "../../images/press-releases/news25.jpg";
import news26 from "../../images/press-releases/news26.jpg";
import news27 from "../../images/press-releases/news27.jpg";
import news28 from "../../images/press-releases/news28.jpg";
import news29 from "../../images/press-releases/news29.jpg";
import news30 from "../../images/press-releases/news30.jpg";
import news31 from "../../images/press-releases/news31.jpg";
import news32 from "../../images/press-releases/news32.jpg";
import news33 from "../../images/press-releases/news33.jpg";
import news34 from "../../images/press-releases/news34.jpg";
import news35 from "../../images/press-releases/news35.jpg";
import news36 from "../../images/press-releases/news36.jpg";
import news37 from "../../images/press-releases/news37.jpg";
import news38 from "../../images/press-releases/news38.jpg"; 
import news39 from "../../images/press-releases/news39.jpg";
import news40 from "../../images/press-releases/news40.jpg";
import news41 from "../../images/press-releases/news41.jpg";
import news42 from "../../images/press-releases/news42.jpg";
import news43 from "../../images/press-releases/news43.jpg";
import news44 from "../../images/press-releases/news44.jpg";
import news45 from "../../images/press-releases/news45.jpg";
import news46 from "../../images/press-releases/news46.jpg";
import news47 from "../../images/press-releases/news47.jpg";
import news48 from "../../images/press-releases/news48.jpg";
import news49 from "../../images/press-releases/news49.jpg";
import news50 from "../../images/press-releases/news50.jpg";
import news51 from "../../images/press-releases/news51.jpg";
import news52 from "../../images/press-releases/news52.jpg";
import news53 from "../../images/press-releases/news53.jpg";
import news54 from "../../images/press-releases/news54.jpg";
import news55 from "../../images/press-releases/news55.jpg";
import news56 from "../../images/press-releases/news56.jpg";
import news57 from "../../images/press-releases/news57.jpg";
import news58 from "../../images/press-releases/news58.jpg";
import news59 from "../../images/press-releases/news59.jpg";
import news60 from "../../images/press-releases/news60.jpg";
import news61 from "../../images/press-releases/news61.jpg";
import news62 from "../../images/press-releases/news62.jpg";
import news63 from "../../images/press-releases/news63.jpg";
import news64 from "../../images/press-releases/news64.jpg";
import news65 from "../../images/press-releases/news65.jpg";
import news66 from "../../images/press-releases/news66.jpg";
import news67 from "../../images/press-releases/news67.jpg";
import news68 from "../../images/press-releases/news68.jpg";
import news69 from "../../images/press-releases/news69.jpg";
import news70 from "../../images/press-releases/news70.jpg";
import news71 from "../../images/press-releases/news71.jpg";
import news72 from "../../images/press-releases/news72.jpg";
import news73 from "../../images/press-releases/news73.jpg";
import news74 from "../../images/press-releases/news74.jpg";
import news75 from "../../images/press-releases/news75.jpg";
import news76 from "../../images/press-releases/news76.jpg";
import news77 from "../../images/press-releases/news77.jpg";
import news78 from "../../images/press-releases/news78.jpg";
import news79 from "../../images/press-releases/news79.jpg";
import news80 from "../../images/press-releases/news80.jpg";
import news81 from "../../images/press-releases/news81.jpg";
import news82 from "../../images/press-releases/news82.jpg";
import news83 from "../../images/press-releases/news83.jpg";
import news84 from "../../images/press-releases/news84.jpg";
import news85 from "../../images/press-releases/news85.jpg";
import news86 from "../../images/press-releases/news86.jpg";
import news87 from "../../images/press-releases/news87.jpg";
import news88 from "../../images/press-releases/news88.jpg";
import news89 from "../../images/press-releases/news89.jpg";
import news90 from "../../images/press-releases/news90.jpg";
import news91 from "../../images/press-releases/news91.jpg";
import news92 from "../../images/press-releases/news92.jpg";
import news93 from "../../images/press-releases/news93.jpg";
import news94 from "../../images/press-releases/news94.jpg";
import news95 from "../../images/press-releases/news95.jpg";
import news96 from "../../images/press-releases/news96.jpg";
import news97 from "../../images/press-releases/news97.jpg";
import news98 from "../../images/press-releases/news98.jpg";
import news99 from "../../images/press-releases/news99.jpg";
import news100 from "../../images/press-releases/news100.jpg";
import news101 from "../../images/press-releases/news101.jpg";
import news102 from "../../images/press-releases/news102.jpg";
import news103 from "../../images/press-releases/news103.jpg";
import news104 from "../../images/press-releases/news104.jpg";
import news105 from "../../images/press-releases/news105.jpg";
import news106 from "../../images/press-releases/news106.jpg";
import news107 from "../../images/press-releases/news107.jpg";
import news108 from "../../images/press-releases/news108.jpg";
function PressReleasesPage() {

  const [currentPage, setCurrentPage] = useState(1);

  const reportsPerPage = 5;

  const newsData = [
    {
      image: news108,
      title:
        "Fremont Hindu Temple Reaffirms Its 43-Year Legacy of Faith, Cultural Preservation, Community Service, and Religious Harmony",
      date: "November 1, 2026",
      desc:
        "Dr. Romesh K. Japra Calls for Mutual Respect, Constructive Dialogue, and Balanced Understanding Following NBC News Coverage of Neighborhood Concerns",
      link: "https://indiapost.com/fremont-hindu-temple-reaffirms-its-43-year-legacy-of-faith-cultural-preservation-community-service-and-religious-harmony/",
    },
    {
      image: news107,
      title:
        "FOG Telugu Bathukamma, A4H Bhajan Clubbing, and A4H PAC Endorsements Unite Culture, Devotion, and Political Empowerment in Sunol",
      date: "November 1, 2026",
      desc:
        "Americans4Hindus Endorses Julie Testa for Pleasanton Mayor and Brett Martinez for Pleasanton Unified School District Board as Community Leaders Join a Successful Cultural and Civic Gathering",
      link: "https://indiapost.com/fog-telugu-bathukamma-a4h-bhajan-clubbing-and-a4h-pac-endorsements-unite-culture-devotion-and-political-empowerment-in-sunol/",
    },
    {
      image: news106,
      title:
        "Fremont Hindu Temple Celebrates Karwa Chauth 2026 with Hundreds of Devotees in a Grand Display of Faith and Tradition",
      date: "November 1, 2026",
      desc:
        "Around 600 Women Participate in Sacred Vrat Katha and Puja as Vedic Dharma Samaj Continues Over Four Decades of Spiritual and Community Service",
      link: "https://indiapost.com/fremont-hindu-temple-celebrates-karwa-chauth-2026-with-hundreds-of-devotees-in-a-grand-display-of-faith-and-tradition/",
    },
    {
      image: news105,
      title:
        "India’s new Consul General in San Francisco, Satish Kumar Sivan, visits the Fremont Hindu Temple.",
      date: "October 27, 2026",
      desc:
        "Consul General Appreciates the Temple’s 41-Year Legacy of Preserving  Hindu Heritage; Founder & Chairman Dr. Romesh K. Japra Extends Warm Welcome and Congratulations",
      link: "https://indiapost.com/indias-new-consul-general-in-san-francisco-satish-kumar-sivan-visits-the-fremont-hindu-temple/",
    },
    {
      image: news104,
      title:
        "FOG Telugu Bathukamma and A4H Bhajan Clubbing Celebrate Culture, Devotion, and Community Unity",
      date: "October 27, 2026",
      desc:
        "The FOG Telugu Bathukamma event, organized under Festival of Globe, and the A4H Bhajan Clubbing event, presented by Americans4Hindus, brought community members together in Sunol, California, for a meaningful celebration of cultural heritage, devotional music, and community spirit.",
      link: "https://indiapost.com/fog-telugu-bathukamma-and-a4h-bhajan-clubbing-celebrate-culture-devotion-and-community-unity/",
    },
    {
      image: news103,
      title:
        "FOG Diwali 2026 celebrated in Fremont with a Ramayana drone show and grand cultural festivities.",
      date: "October 27, 2026",
      desc:
        "Americans4Hindus Presents Breathtaking Lord Hanuman-Themed Aerial Spectacle as Festival Welcomes an Estimated 25,000 Attendees",
      link: "https://indiapost.com/fog-diwali-2026-celebrated-in-fremont-with-a-ramayana-drone-show-and-grand-cultural-festivities/",
    },

    {
      image: news102,
      title:
        "A4H Bhajan Clubbing Michigan 2026 Celebrates Spectacular Success with Nearly 500 Participants",
      date: "October 27, 2026",
      desc:
        "Dr. Romesh K. Japra Congratulates A4H Michigan Chapter Team for an Outstanding Celebration of Devotion,  Music, and Cultural Unity",
      link: "https://indiapost.com/a4h-bhajan-clubbing-michigan-2026-celebrates-spectacular-success-with-nearly-500-participants/",
    },
    {
      image: news101,
      title:
        "Americans4Hindus Endorses Paul Sethy for ACWD Director, Ward 3",
      date: "October 27, 2026",
      desc:
        "Dr. Romesh K. Japra Recognizes 16 Years of Public Service and Commitment to Southern Fremont FREMONT, CALIFORNIA — October 2026 Americans4Hindus (A4H) proudly endorses Paul Sethy for...",
      link: "https://indiapost.com/americans4hindus-endorses-paul-sethy-for-acwd-director-ward-3/",
    },
    {
      image: news100,
      title:
        "Americans4Hindus PAC’s Colorado chapter has expanded engagement with Rep. Jason Crow and endorsed Phil Weiser for governor.",
      date: "October 27, 2026",
      desc:
        "Dr. Janak Joshi and Dev Bhattacharya Lead Two Successful Political Engagements; Dr. Romesh K. Japra Applauds Colorado Chapter’s Leadership Americans4Hindus PAC (A4H PAC) Colorado Chapter...",
      link: "https://indiapost.com/americans4hindus-pacs-colorado-chapter-has-expanded-engagement-with-rep-jason-crow-and-endorsed-phil-weiser-for-governor/",
    },
    {
      image: news99,
      title:
        "Americans4Hindus Releases A4H Voter Guide 2026 Ahead of November 3 General Election",
      date: "October 23, 2026",
      desc:
        "Nationwide, Silicon Valley, and California Propositions Guides Help Voters Make Informed Electoral Decisions Fremont, California: Americans4Hindus (A4H) has released its A4H Voter Guide 2026, providing members...",
      link: "https://indiapost.com/americans4hindus-releases-a4h-voter-guide-2026-ahead-of-november-3-general-election/",
    },
    {
      image: news98,
      title:
        "Americans4Hindus endorses Steve Hilton for California Governor; Dr. Romesh K. Japra extends support at San Jose Community Rally",
      date: "October 22, 2026",
      desc:
        "Dr Abhilash Maroju SAN JOSE, CALIFORNIA: Americans4Hindus (A4H) a bipartisan political action organization dedicated to strengthening the political voice of Hindu Americans and Pro-Hindus, has...",
      link: "https://indiapost.com/americans4hindus-endorses-steve-hilton-for-california-governor-dr-romesh-k-japra-extends-support-at-san-jose-community-rally/",
    },
    {
      image: news97,
      title:
        "Americans4Hindus Urges Practical Security Measures to Ensure Safe Navratri and Dasara Celebrations Nationwide",
      date: "October 17, 2026",
      desc:
        "Fremont, California — October 16, 2026 Americans4Hindus (A4H) urges Hindu temples, community organizations, families, and devotees across the United States to celebrate Navratri and Dasara 2026 with...",
      link: "https://indiapost.com/americans4hindus-urges-practical-security-measures-to-ensure-safe-navratri-and-dasara-celebrations-nationwide/"
    },    
    {
      image: news96,
      title:
        "Americans4Hindus Calls for Urgent International Intervention to Protect Sri Lankan Hindu Facing Death Sentence in Saudi Arabia",
      date: "October 16, 2026",
      desc:
        "A4H Urges Diplomatic Action, Due Process, and Protection of Fundamental Human Rights Fremont, California — October 15, 2026 Americans4Hindus (A4H) expresses grave concern over reports that Anojan...",
      link: "https://indiapost.com/americans4hindus-calls-for-urgent-international-intervention-to-protect-sri-lankan-hindu-facing-death-sentence-in-saudi-arabia/"
    },
    {
      image: news93,
      title:
        "Americans4Hindus Endorses Gloria Romero, Keith Parker, and Jason Lin for the 2026 California Elections",
      date: "October 16, 2026",
      desc:
        "Dr. Romesh Japra Presents Endorsement Certificates and Campaign Contribution Checks at Fremont Endorsement Meeting Fremont, California — October 15, 2026 Americans4Hindus (A4H) announced three new endorsements for the...",
      link: "https://indiapost.com/americans4hindus-endorses-gloria-romero-keith-parker-and-jason-lin-for-the-2026-california-elections/"
    },
    {
      image: news94,
      title:
        "Americans4Hindus Released Its 2026 Bay Area Voter Guide Ahead of November 3",
      date: "October 15, 2026",
      desc:
        "Dr Abhilash Maroju SAN FRANCISCO BAY AREA, CALIFORNIA: Americans4Hindus (A4H) is encouraging eligible voters throughout the San Francisco Bay Area to prepare for the upcoming...",
      link: "https://indiapost.com/americans4hindus-released-its-2026-bay-area-voter-guide-ahead-of-november-3/"
    },
    {
      image: news95,
      title:
        "Americans4Hindus PAC Michigan Chapter Endorses Republican U.S. Senate Candidate Mike Rogers",
      date: "October 12, 2026",
      desc:
        "Troy, Michigan — October 11, 2026 Americans4Hindus (A4H PAC) Michigan Chapter officially endorsed Mike Rogers, Republican candidate for the United States Senate from Michigan, during an endorsement...",
      link: "https://indiapost.com/americans4hindus-pac-michigan-chapter-endorses-republican-u-s-senate-candidate-mike-rogers/"
    },
    {
      image: news90,
      title:
        "Americans4Hindus Announces Three New Endorsements in Bay Area, California for the 2026 Elections",
      date: "October 12, 2026",
      desc:
        "A4H Team Presents Endorsement Certificates to Herb Morgan, LiangFang Chao, and Bill Chuan in Fremont, California Fremont, California — October 10, 2026 Americans4Hindus (A4H), a political organization committed to...",
      link: "https://indiapost.com/americans4hindus-announces-new-2026-endorsement-of-congresswoman-suzan-delbene-in-washington-state/"
    },
    {
      image: news91,
      title:
        "Americans4Hindus Expresses Support for Congressman James Walkinshaw at McLean Fundraiser",
      date: "October 10, 2026",
      desc:
        "A4H Founder and Chairman Dr. Romesh Japra extends his support and best wishes to Congressman Walkinshaw as A4H leaders engage with him on issues...",
      link: "https://indiapost.com/americans4hindus-expresses-support-for-congressman-james-walkinshaw-at-mclean-fundraiser/"
    },
    {
      image: news92,
      title:
        "Americans4Hindus Trustees Mr. & Mrs. Anil Sharma and Anupama Sharma Honored by George Mason University",
      date: "October 9, 2026",
      desc:
        "University names Center for Innovation and Entrepreneurship in their honor WASHINGTON, D.C. — October 8, 2026 Americans4Hindus proudly congratulates its Trustee Anil Sharma and his wife, Anupama...",
      link: "https://indiapost.com/americans4hindus-trustees-mr-mrs-anil-sharma-and-anupama-sharma-honored-by-george-mason-university/"
    },
    {
      image: news89,
      title:
        "Americans4Hindus announces new 2026 endorsement of Congresswoman Suzan DelBene in Washington State",
      date: "October 5, 2026",
      desc:
        "A4H Founder & Chairman Dr. Romesh Japra supports endorsement as Washington Chapter continues expanding civic and political engagement Dr Abhilash Maroju SEATTLE, Washington: Americans4Hindus has announced...",
      link:
        "https://indiapost.com/americans4hindus-announces-new-2026-endorsement-of-congresswoman-suzan-delbene-in-washington-state/"
    },
    {
      image: news88,
      title:
        "Americans4Hindus announces endorsement of Jenny Rae Le Roux for U.S. Congress",
      date: "September 14, 2026",
      desc:
        "By Dr. Abhilash Maroju National Committee Holds Interactive Meeting with California Congressional Candidate CALIFORNIA: Americans4Hindus (A4H) announced that its National Committee has endorsed Jenny Rae Le Roux, the Republican...",
      link:
        "https://indiapost.com/americans4hindus-announces-endorsement-of-jenny-rae-le-roux-for-u-s-congress/"
    },
    {
      image: news87,
      title:
        "Americans4Hindus Presents a Grand Red Carpet Celebration of Hanuman Ansh in Fremont, CA",
      date: "September 13, 2026",
      desc:
        "A Celebration of Cinema, Culture, Devotion and the Growing Voice of the Hindu-American Community FREMONT, CALIFORNIA: Americans4Hindus (A4H), in association with Festival of Globe and...",
      link:
        "https://indiapost.com/americans4hindus-presents-a-grand-red-carpet-celebration-of-hanuman-ansh-in-fremont-ca/"
    },
    {
      image: news86,
      title:
        "Americans4Hindus extends support to Fremont City Council candidates Vipin Sharma and Manisha Pathak",
      date: "September 11, 2026",
      desc:
        "FREMONT, CALIFORNIA: Americans4Hindus has formally endorsed Vipin Sharma, candidate for Fremont City Council District 3, reaffirming its commitment to supporting Hindu candidates who step...",
      link:
        "https://indiapost.com/americans4hindus-extends-support-to-fremont-city-council-candidates-vipin-sharma-and-manisha-pathak/"
    },
    {
      image: news85,
      title:
        "Americans4Hindus holds Inaugural Rajneeti Summit for political empowerment/education",
      date: "September 3, 2026",
      desc:
        "Milpitas, CA: The inaugural Rajneeti Summit – a political summit, along with a West Coast Retreat for A4H representatives – was held on Friday, August 14th, 2026, from 10 a.m. to 4 p.m. at the Sheraton, Silicon Valley in Milpitas, California...",
      link:
        "https://indiapost.com/americans4hindus-holds-inaugural-rajneeti-summit-for-political-empowerment-education/"
    },
    {
      image: news84,
      title:
        "Americans4Hindus and Festival of Globe deliver a landmark celebration across Silicon Valley and Fremont",
      date: "August 20, 2026",
      desc:
        "SILICON VALLEY & FREMONT, CA: What began as a week-long celebration of friendship, culture and civic leadership culminated in an extraordinary showcase of Indian-American...",
      link: "https://indiapost.com/americans4hindus-and-festival-of-globe-deliver-a-landmark-celebration-across-silicon-valley-and-fremont/"
    },
    {
      image: news83,
      title:
        "Americans4Hindus mourns the passing of United States Senator Lindsey Graham",
      date: "July 17, 2026",
      desc:
        "A nation remembers a dedicated public servant and patriot. Dr. Abhilash Maroju WASHINGTON, D.C.: Americans4Hindus (A4H) expresses its profound sorrow over the sudden and untimely passing of United States Senator Lindsey Graham, honoring his legacy of public service and commitment to the nation...",
      link: "https://indiapost.com/americans4hindus-mourns-the-passing-of-united-states-senator-lindsey-graham/"
    },
    {
      image: news82,
      title:
        "Americans4Hindus & Britons4Hindus host Dr. Yash Gupta in Silicon Valley on “Science in Sanskrit Scriptures”",
      date: "July 2, 2026",
      desc:
        "The spirit of Sanatana Dharma, scientific inquiry, and global Hindu unity came together in an extraordinary evening as Americans4Hindus (A4H) and Britons4Hindus hosted Dr. Yash Gupta for an insightful talk on 'Science in Sanskrit Scriptures.' FREMONT, CA: The event highlighted the timeless wisdom of Sanskrit texts and their relevance to modern scientific thought...",
      link: "https://indiapost.com/americans4hindus-britons4hindus-host-dr-yash-gupta-in-silicon-valley-on-science-in-sanskrit-scriptures/"
    },
    {
      image: news81,
      title:
        "Americans4Hindus endorses Rod Vilhauer for Mayor of Frisco, Texas; strengthens Hindu American civic engagement and local leadership",
      date: "June 12, 2026",
      desc:
        "Americans4Hindus (A4H) proudly endorses Rod Vilhauer for Mayor of Frisco, Texas, reinforcing its commitment to strengthening Hindu American civic engagement and local leadership. Dr. Abhilash Maroju FRISCO, TEXAS: Americans4Hindus (A4H), a national independent and non-partisan organization dedicated to empowering Hindu and pro-Hindu Americans through civic engagement and political...",
      link: "https://indiapost.com/americans4hindus-endorses-rod-vilhauer-for-mayor-of-frisco-texas-strengthens-hindu-american-civic-engagement-and-local-leadership/"
    },
    {
      image: news80,
      title:
        "Americans4Hindus exceeds fundraising goal at Potomac reception endorsing Andrew Friedson for Montgomery County Executive",
      date: "June 12, 2026",
      desc:
        "Americans4Hindus (A4H) exceeds its fundraising goal at a successful Potomac reception endorsing Andrew Friedson for Montgomery County Executive. Dr. Abhilash Maroju POTOMAC, MARYLAND: Americans4Hindus (A4H), a national independent and non-partisan organization dedicated to empowering Hindu and pro-Hindu Americans through civic engagement and political...",
      link: "https://indiapost.com/americans4hindus-exceeds-fundraising-goal-at-potomac-reception-endorsing-andrew-friedson-for-montgomery-county-executive/"
    },
    {
      image: news78,
      title:
        "Americans4Hindus endorses Congressman Bill Huizenga for re-election in Michigan.",
      date: "June 4, 2026",
      desc:
        "Americans4Hindus proudly endorses Congressman Bill Huizenga for re-election; strengthens Hindu American Civic and Congressional engagement in Michigan Dr. Abhilash Maroju MICHIGAN: Americans4Hindus (A4H), a national independent...",
      link: "https://indiapost.com/americans4hindus-endorses-congressman-bill-huizenga-for-re-election-in-michigan/"
    },
    {
      image: news79,
      title:
        "Steve Hilton receives community endorsement by Americans4Hindus at Fremont Hills reception hosted by Dr. Tae Yun Kim",
      date: "June 4, 2026",
      desc:
        "Rakhi Sharma FREMONT, CA: Community leaders, business owners, professionals, and residents gathered in Fremont Hills for a special reception hosted by Dr. Tae Yun Kim,...",
      link: "https://indiapost.com/steve-hilton-receives-community-endorsement-by-americans4hindus-at-fremont-hills-reception-hosted-by-dr-tae-yun-kim/"
    },
    {
      image: news1,
      title:
        "Americans4Hindus launches sister organization Britons4Hindus; to advance Hindu Civic leadership and democratic engagement in UK",
      date: "May 28, 2026",
      desc:
        "Dr. Abhilash Maroju LONDON: In a landmark milestone for global Hindu civic and political engagement, Americans4Hindus (A4H) proudly launched its sister organization, Britons4Hindus (B4H), in...",
      link: "https://indiapost.com/americans4hindus-launches-sister-organization-britons4hindus-to-advance-hindu-civic-leadership-and-democratic-engagement-in-uk/#google_vignette"
    },
    {
      image: news2,
      title:
        "Americans4Hindus expands national reach with launch of New Mexico Chapter",
      date: "April 16, 2026",
      desc:
        "Dr. Abhilash Maroju Americans4Hindus (A4H), a national, independent, non-partisan political organization dedicated to empowering Hindu and pro-Hindu Americans, proudly announced the successful launch of its...",
      link: "https://indiapost.com/americans4hindus-expands-national-reach-with-launch-of-new-mexico-chapter/"
    },
    {
      image: news3,
      title:
        "Americans4Hindus Oregon Launch: Strengthening National Influence",
      date: "April 16, 2026",
      desc:
        "Dr. Abhilash Maroju Americans4Hindus (A4H), a national, independent, non-partisan political organization dedicated to empowering Hindu and pro-Hindu Americans, proudly announced the successful launch of its...",
      link: "https://indiapost.com/americans4hindus-oregon-launch-strengthening-national-influence/"
    },
    {
      image: news4,
      title:
        "Americans4Hindus launches in Washington State, strengthening Hindu American civic leadership and policy influence.",
      date: "April 16, 2026",
      desc:
        "Dr. Abhilash Maroju Americans4Hindus (A4H), a national, independent, non-partisan political organization committed to empowering Hindu and pro-Hindu Americans, proudly announced the successful inauguration of its...",
      link: "https://indiapost.com/americans4hindus-launches-in-washington-state-strengthening-hindu-american-civic-leadership-and-policy-influence/",
    },
    {
      image: news5,
      title:
        "Americans4Hindus Grows National Footprint in Philadelphia",
      date: "April 9, 2026",
      desc:
        "Dr. Abhilash Maroju PHILADELPHIA, PA: Americans4Hindus (A4H), a national, independent, non-partisan political organization dedicated to empowering Hindu and pro-Hindu Americans, proudly announced the launch of...",
      link: "https://indiapost.com/americans4hindus-grows-national-footprint-in-philadelphia/",
    },
    {
      image: news6,
      title:
        "Americans4Hindus & partner organizations host Congressman Jimmy Patronis in Florida",
      date: "April 3, 2026",
      desc:
        "Dr. Abhilash Maroju TAMPA, FL: Americans4Hindus (A4H), in collaboration with the Hindu-Jewish Coalition of America (HJCA) and other leading community institutions, recently hosted a series...",
      link: "https://indiapost.com/americans4hindus-partner-organizations-host-congressman-jimmy-patronis-in-florida/",
    },
    {
      image: news7,
      title:
        "Americans4Hindus expands footprint with four new state chapters in New Orleans",
      date: "April 3, 2026",
      desc:
        "Dr. Abhilash Maroju NEW ORLEANS, LA: In a major move to bolster civic engagement within the Hindu American community, Americans4Hindus (A4H) officially launched four new...",
      link:
        "https://indiapost.com/americans4hindus-expands-footprint-with-four-new-state-chapters-in-new-orleans/",
    },
    {
      image: news8,
      title:
        "Phagwara-Born Dr. Romesh Japra Leads Americans4Hindus Expansion, Advocates Greater Civic Role for Hindu Americans",
      date: "March 18, 2026",
      desc:
        "ASHOK KAURA PHAGWARA: Highlighting the growing role of diaspora leadership in shaping civic engagement abroad, Phagwara-born cardiologist Dr. Romesh Japra continues to spearhead the expansion of...",
      link:
        "https://indiapost.com/phagwara-born-dr-romesh-japra-leads-americans4hindus-expansion-advocates-greater-civic-role-for-hindu-americans/",
    },
    {
      image: news9,
      title:
        "Americans4Hindus launches Arizona State Chapter in Phoenix",
      date: "February 5, 2026",
      desc:
        "Arizona becomes the 24th State Chapter in A4H’s rapid national expansion PHOENIX, ARIZONA: Americans4Hindus (A4H), the nation’s fastest-growing Hindu American political empowerment organization, proudly announced...",
      link:
        "https://indiapost.com/americans4hindus-launches-arizona-state-chapter-in-phoenix/",
    },
    {
      image: news10,
      title:
        "Americans4Hindus hosts virtual Meet & Greet with New York Attorney General candidate Saritha Komatireddy",
      date: "December 26, 2025",
      desc:
        "India Post News Service (A4H) successfully hosted a virtual Meet & Greet on December 21 with, a distinguished American Hindu leader and candidate for Attorney...",
      link:
        "https://indiapost.com/americans4hindus-hosts-virtual-meet-greet-with-new-york-attorney-general-candidate-saritha-komatireddy/",
    },
  {
    image: news11,
    title: "Americans4Hindus launches Rajneeti Academy 2026",
    date: "December 19, 2025",
    desc: "A National Weekly Political Empowerment series with multi-level certifications IT’S TIME TO LEAD - ENTER POLITICS, SHAPE THE FUTURE India Post News Service Americans4Hindus (A4H), a national...",
    link: "https://indiapost.com/americans4hindus-launches-rajneeti-academy-2026/"
  },
  {
    image: news12,
    title: "Americans4Hindus launches its 21st State Chapter in Florida",
    date: "December 11, 2025",
    desc: "A Major Milestone in the Rapid National Expansion of A4H India Post News Service Americans4Hindus (A4H), one of the fastest-growing political empowerment organizations for Hindu Americans,...",
    link: "https://indiapost.com/americans4hindus-launches-its-21st-state-chapter-in-florida/"
  },
  {
    image: news13,
    title: "Americans4Hindus Proudly Endorses Janak Joshi for U.S. Senate",
    date: "December 11, 2025",
    desc: "A historic moment for Hindu and Indian American representation India Post News Service WASHINGTON, D.C.: Americans4Hindus (A4H), a national independent political organization dedicated to empowering Hindu...",
    link: "https://indiapost.com/americans4hindus-proudly-endorses-janak-joshi-for-u-s-senate/"
  },
  {
    image: news14,
    title: "Americans4Hindus launches New Colorado Chapter in Denver",
    date: "November 27, 2025",
    desc: "India Post News Service DENVER, COLORADO: Americans4Hindus (A4H), the nation’s fastest-growing Hindu American political empowerment organization, proudly announced the official launch of its Colorado State...",
    link: "https://indiapost.com/americans4hindus-launches-new-colorado-chapter-in-denver/"
  },
  {
    image: news15,
    title: "Americans4Hindus launches new Ohio Chapter in Columbus",
    date: "November 21, 2025",
    desc: "Historic inauguration marks a major step in Political Empowerment for Hindu Americans India Post News Service COLUMBUS, OHIO: Americans4Hindus (A4H), the national political organization dedicated to...",
    link: "https://indiapost.com/americans4hindus-launches-new-ohio-chapter-in-columbus/"
  },
  {
    image: news16,
    title: "Bengal Files producers Vivek Agnihotri and Pallavi Joshi honored by Americans4Hindus",
    date: "August 13, 2025",
    desc: "Ritu Maheshwari India Post News Service FREMONT, CA: Vivek Agnihotri and Pallavi Joshi duo, known for several thought provoking hit movies such as Kashmir Files were...",
    link: "https://indiapost.com/americans4hindus-bengal-files-producers-vivek-agnihotri-pallavi-joshi- honored/"
  },
  {
    image: news17,
    title: "Americans4Hindus Condemns Gunfire Incidents at ISKCON Utah as Potential Hate Crimes; Urges FBI Investigation",
    date: "July 7, 2025",
    desc: "July 4, 2025 – USA: Americans4Hindus expresses deep concern over recent nighttime gunfire incidents reported at the ISKCON Temple in Utah. These alarming acts, which...",
    link: "https://indiapost.com/americans4hindus-condemns-gunfire-incidents-at-iskcon-utah-as-potential-hate-crimes-urges-fbi-investigation/"
  },
  {
    image: news18,
    title: "Americans4Hindus leads fund raiser for Santa Clara District Attorney Jeff Rosen",
    date: "June 12, 2025",
    desc: "Ritu Maheshwari India Post News Service SARATOGA, CA: On June 8th, 2025 Americans4Hindus, a Super PAC focused on empowering, uniting and elevating Hindu values and voice...",
    link: "https://indiapost.com/americans4hindus-leads-fund-raiser-for-santa-clara-district-attorney_jeff-rosen/"
  },
  {
    image: news19,
    title: "Hindu Jewish Wing of Americans4Hindus condemns boulder terror attack and stands with Jewish community in the fight against hate",
    date: "June 4, 2025",
    desc: "India Post News Service WASHINGTON, D.C.: The Hindu Jewish Wing of Americans4Hindus (A4H) unequivocally condemns the brutal act of violence that recently occurred in Boulder,...",
    link: "https://indiapost.com/hindu-jewish-wing-of-americans4hindus-condemns-boulder-terror-attack-and-stands-with-jewish-community-in-the-fight-against-hate/"
  },
  {
    image: news20,
    title: "Americans4Hindus endorses Anthony Rendon for California State Treasurer",
    date: "March 14, 2025",
    desc: "Ritu Maheshwari India Post News Service Fremont, CA: Americans4Hindus strongly endorsed the candidature of California speaker Emeritus Anthony Rendon for California State Treasurer in upcoming 2026...",
    link: "https://indiapost.com/americans4hindus-endorses-anthony-rendon-for-california-state-treasurer/"
  },
  {
    image: news21,
    title: "Americans4Hindus hosts landmark series of events in Washington D.C., empowering and uniting the Hindu community",
    date: "January 31, 2025",
    desc: "Dr. Abhilash Maroju WASHINGTON D.C.: A series of high-profile events hosted by Americans4Hindus (A4H) in the heart of the nation’s capital underscored the growing political...",
    link: "https://indiapost.com/americans4hindus-hosts-landmark-series-of-events-in-washington-d-c-empowering-and-uniting-the-hindu-community/"
  },
  {
    image: news22,
    title: "Americans4Hindus Congratulates President-Elect Donald Trump on Election Victory",
    date: "November 7, 2024",
    desc: "Romesh Japra Americans4Hindus extends heartfelt congratulations to President-Elect Donald Trump on his successful election victory. We commend his vision and commitment to 'Make America Great...'",
    link: "https://indiapost.com/americans4hindus-congratulates-president-elect-donald-trump-on-election-victory/"  
  },
  {
    image: news23,
    title: "Americans4Hindus promotes Hindu values in American policy making at Diwali Gala",
    date: "November 1, 2024",
    desc: "Ritu Maheshwari India Post News Service Milpitas, CA: Americans4Hindus organized a Grand Diwali Dinner Gala to celebrate largest Indian Festival of Lights Diwali. Diwali Gala was...",
    link: "https://indiapost.com/americans4hindus-promotes-hindu-values-in-american-policy-making-at-diwali-gala/"
  },
  {
    image: news24,
    title: "Americans4Hindus endorses Madison Nguyen for Santa Clara County Supervisor",
    date: "August 2, 2024",
    desc: "Ritu Maheshwari India Post News Service San Jose, CA: In its drive to promote, support and encourage Pro-Hindu candidates in local elections, Americans4Hindus endorsed Madison Nguyen...",
    link: "https://indiapost.com/americans4hindus-endorses-madison-nguyen-for-santa-clara-county-supervisor/"
  },
  {
    image: news25,
    title: "Americans4Hindus endorses Sunnyvale Mayor Larry Klein reelection campaign",
    date: "July 25, 2024",
    desc: "Dr. Abhilash Maroju On July 21st, 2024, Sunnyvale residents and esteemed dignitaries gathered at Vishnuji Ki Rasoi to rally behind Mayor Larry Klein's bid for...",
    link: "https://indiapost.com/americans4hindus-endorses-sunnyvale-mayor-larry-klein-reelection-campaign/"
  },
  {
    image: news26,
    title: "Americans4Hindus launches Hindu Rajneeti Academy",
    date: "May 4, 2024",
    desc: "Ritu Maheshwari India Post News Service FREMONT, CA: Americans4Hindus launched ‘Hindu Rajneeti Academy’ to focus on political education, enlightenment and empowerment on Sunday, April 28th at...",
    link: "https://indiapost.com/americans4hindus-launches-hindu-rajneeti-academy/"
  },
  {
    image: news27,
    title: "Americans4Hindus organized a fundraiser for Arjun Batra",
    date: "December 8, 2023",
    desc: "Ritu Maheshwari India Post News Service SAN JOSE, CA: Americans4Hindus organized a fundraiser for Arjun Batra for his City of San Jose District 10 City Council...",
    link: "https://indiapost.com/americans4hindus-organized-a-fundraiser-for-arjun-batra/"
  },
  {
    image: news28,
    title: "Americans4Hindus backs Vin Kruttiventi’s run for US Congress",
    date: "September 28, 2023",
    desc: "Another Indian American has jumped into the fray of political candidates. Vin Kruttiventi recently announced his run for U.S. Congress from California’s District 14,...",
    link: "https://indiapost.com/americans4hindus-backs-vin-kruttiventi’s-run-for-us-congress/"
  },
  {
    image: news29,
    title: "Pamela Price, supported by ‘Americans4Hindus’ wins Alameda District Attorney Election",
    date: "November 24, 2022",
    desc: "Ritu Maheshwari India Post News Service Oakland, CA: Pamela Price won the election for District Attorney from Alameda County. Pamela is a civil rights attorney and...",
    link: "https://indiapost.com/pamela-price-supported-by-americans4hindus-wins-alameda-district-attorney-election/"
  },
  {
    image: news30,
    title: "Americans for Hindus (A4H, www.Americans4Hindus.org) Hosts Senator Cindy Hyde Smith",
    date: "October 19, 2020",
    desc: "India Post News Service October 15, was a special day for Americans4Hindus, a non-partisan SuperPAC created to be the political voice of the global Hindus...",
    link: "https://indiapost.com/americans-for-hindus-a4h-www-americans4hindus-org-hosts-senator-cindy-hyde-smith/"
  },
  {
    image: news31,
    title: "Hindu Civilizational Renaissance: A Call to Action for the Hindu Diaspora",
    date: "May 28, 2026",
    desc: "Hindu Civilizational Renaissance: A Call to Action for the Hindu Diaspora is a visionary and action-oriented playbook for the 21st century—designed to inspire, organize,...",
    link: "https://indiapost.com/hindu-civilizational-renaissance-a-call-to-action-for-the-hindu-diaspora/"
  },
  {
    image: news32,
    title: "Gunman kills Canadian tourist, injures several at Mexico’s Teotihuacan Pyramids: Reports",
    date: "April 21, 2026",
    desc: "WASHINGTON: A shooting at the historic Teotihuacan pyramids has left a Canadian tourist dead and multiple others injured, according to a report by CNN,...",
    link: "https://indiapost.com/gunman-kills-canadian-tourist-injures-several-at-mexico-s-teotihuacan-pyramids-reports/"
  },
  {
    image: news33,
    title: "A4H Colorado Chapter and Sewa International host community leaders’ meet with Consul General of India",
    date: "April 3, 2026",
    desc: "Dr. Abhilash Maroju COLORADO: In a significant display of community unity and civic engagement, the Americans4Hindus (A4H) Colorado Chapter, in collaboration with Sewa International, hosted a...",
    link: "https://indiapost.com/a4h-colorado-chapter-and-sewa-international-host-community-leaders-meet-with-consul-general-of-india/"
  },
  {
    image: news34,
    title: "Dr. Romesh Japra urges human-centered global framework for ethical AI",
    date: "February 19, 2026",
    desc: "Ashok Kaura India Post News Service PHAGWARA/DELHI: California based, Phagwara-born, Dr. Romesh Japra, Founder and Chairman of Americans4Hindus (A4H), while participating in India-AI Summit 2026 in...",
    link: "https://indiapost.com/dr-romesh-japra-urges-human-centered-global-framework-for-ethical-ai/"
  },
  {
    image: news35,
    title: "San Francisco NRI community hosts grand celebration of the Bihar election victory",
    date: "November 27, 2025",
    desc: "India Post News Service SAN FRANCISCO, CA: The Bay Area’s Indian American community came together in a powerful show of unity and pride on Thursday,...",
    link: "https://indiapost.com/san-francisco-nri-community-hosts-grand-celebration-of-the-bihar-election-victory/"
  },
  {
    image: news36,
    title: "HISTORIC A4H MEET",
    date: "November 14, 2025",
    desc: "Americans4Hindus hosts Historic 'Americans4Hindus Week' in Washington, D.C. WASHINGTON, D.C.: Americans4Hindus hosts Historic 'Americans4Hindus Week' in Washington, D.C., A National Call for Political Engagement and...",
    link: "https://indiapost.com/historic-a4h-meet/"
  },
  {
    image: news37,
    title: "City of Milpitas presents Proclamation to celebrate Diwali and Hindu Heritage month",
    date: "October 31, 2025",
    desc: "Ritu Maheshwari India Post News Service Milpitas, CA: On Tuesday, October 21, 2025, the Proclamation for Diwali the Hindu Festival of Lights was presented by the...",
    link: "https://indiapost.com/city-of-milpitas-presents-proclamation-to-celebrate-diwali-and-hindu-heritage-month/"
  },
  {
    image: news38,
    title: "FOG India Day Parade the largest India Day Parade in USA",
    date: "September 4, 2025",
    desc: "Ritu Maheshwari India Post News Service 33rd FOG India Day Parade was held with zeal, enthusiasm and patriotism. This year’s theme of the parade was unity...",
    link: "https://indiapost.com/fog-india-day-parade-the-largest-india-day-parade-in-usa/"
  },
  {
    image: news39,
    title: "FOG India Day 2025 Cultural Celebrations huge success with several thousands attended",
    date: "August 29, 2025",
    desc: "India Post News Service FOG/FIA India Day Cultural Celebrations with Dance competitions and performances was a huge success with 1200 kids/adults participating and several thousands...",
    link: "https://indiapost.com/fog-india-day-2025-cultural-celebrations-huge-success-with-several-thousands-attended/"
  },
  {
    image: news40,
    title: "“Everything was planned..”: Mithun Chakraborty reacts to ‘The Bengal Files’ controversy",
    date: "August 20, 2025",
    desc: "MUMBAI: Filmmaker Vivek Ranjan Agnihotri’s directorial 'The Bengal Files', which focuses on the events of the Direct Action Day and the 1946 Calcutta killings,...",
    link: "https://indiapost.com/everything-was-planned-mithun-chakraborty-reacts-to-the-bengal-files-controversy/"
  },
  {
    image: news41,
    title: "Celebrating Diwali and Making History in California",
    date: "May 8, 2025",
    desc: "Nishtha Raheja Goel Last year, Los Angeles City Councilmember Nithya Raman graciously invited the Valley Indian Seniors Association (VISA)—a non-profit organization dedicated to empowering, educating,...",
    link: "https://indiapost.com/celebrating-diwali-and-making-history-in-california/"
  },
  {
    image: news42,
    title: "Targeting of Hindu Americans delegates by the radically progressive: The SB 509 Quagmire",
    date: "May 2, 2025",
    desc: "Geeta Sikand VP Communications, Americans4Hindus Recently, Governor Newsom called his party 'toxic' and out of touch in a refreshing and informative podcast (LA Times, March 30th,...",
    link: "https://indiapost.com/targeting-of-hindu-americans-delegates-by-the-radically-progressive-the-sb-509-quagmire/"
  },
  {
    image: news43,
    title: "In Loving Memory of Dr. Sampat Shivangi",
    date: "February 12, 2025",
    desc: "Romesh Japra Dear Friends, It is with profound sadness that we share the heartbreaking news of the passing of Dr. Sampat Shivangi, one of the...",
    link: "https://indiapost.com/in-loving-memory-of-dr-sampat-shivangi/"
  },
  {
    image: news44,
    title: "A4H celebrates arrival of New Year with a fun filled event",
    date: "January 10, 2025",
    desc: "Ritu Maheshwari India Post News Service FREMONT, CA: Americans4Hindus (A4H) members and Pro-Hindu supporters gathered to welcome 2025 New Year in style. The event was held...",
    link: "https://indiapost.com/a4h-celebrates-arrival-of-new-year-with-a-fun-filled-event/"
  },
  {
    image: news45,
    title: "A4H celebrates election of Pro Hindu candidates",
    date: "November 15, 2024",
    desc: "FREMONT, CA: Americans4Hindus organized an Election results watch party on the evening of November 5th for its members to gather...",
    link: "https://indiapost.com/a4h-celebrates-election-of-pro-hindu-candidates/"
  },
  {
    image: news46,
    title: "Americans for Hindus Condemns Attack on Hindu Sabha Mandir in Brampton, Urges U.S. Congressional Action",
    date: "November 6, 2024",
    desc: "India Post News Service WASHINGTON, DC: Americans for Hindus (A4H) strongly condemns the violent attack on the Hindu Sabha Mandir in Brampton, Canada, an act...",
    link: "https://indiapost.com/americans-for-hindus-condemns-attack-on-hindu-sabha-mandir-in-brampton-urges-u-s-congressional-action/"
  },
  {
    image: news47,
    title: "A4H supports Buddhist Coalition leader Hon Lien’s Milpitas Mayor bid",
    date: "October 18, 2024",
    desc: "India Post News Service MILPITAS, CA: Americans4Hindus organized a Meet and Greet and Fundraiser for Hon Lien, Mayoral candidate for Milpitas City. Ms. Lien is...",
    link: "https://indiapost.com/a4h-supports-buddhist-coalition-leader-hon-lien's-milpitas-mayor-bid/"
  },
  {
    image: news48,
    title: "President Biden bestows Lifetime Achievement Award on Dr. Romesh Japra",
    date: "August 30, 2024",
    desc: "India Post News Service WASHINGTON DC: In a significant recognition of Dr. Romesh Japra’s lifelong commitment to community service, President Joe R. Biden awarded him...",
    link: "https://indiapost.com/president-biden-bestows-lifetime-achievement-award-on-dr-romesh-japra/"
  },
  {
    image: news49,
    title: "Dr. Japra conferred Community Advocate and Leadership award",
    date: "August 9, 2024",
    desc: "Dr. Abhilash Maroju OAKLAND: Multi-Ethnic Sports Hall Of Fame (MESHOF) Annual Gala was abuzz with excitement on Sunday, August 3, 2024, as it honored a...",
    link: "https://indiapost.com/dr-japra-conferred-community-advocate-and-leadership-award/"
  },
  {
    image: news50,
    title: "Community rallies for Fiona Ma’s bid for California Lieutenant Governor",
    date: "August 9, 2024",
    desc: "Dr. Abhilash Maroju PALO ALTO, CA: On Sunday, August 3rd, 2024, a significant event in Silicon Valley underscored the growing momentum behind Fiona Ma’s campaign...",
    link: "https://indiapost.com/community-rallies-for-fiona-ma’s-bid-for-california-lieutenant-governor/"
  },
  {
    image: news51,
    title: "Campaign Kick-off for Chandra Wagh: A Journey of Commitment and Community",
    date: "July 18, 2024",
    desc: "Abhilash Maroju FREMONT, CA: On Sunday, July 14, 2024, at Lone Tree Park in Fremont, a vibrant campaign kick-off marked the beginning of Mr. Chandra...",
    link: "https://indiapost.com/campaign-kick-off-for-chandra-wagh-a-journey-of-commitment-and-community/"
  },
  {
    image: news52,
    title: "American Hindu Launches Election Campaign in Santa Clara, CA",
    date: "July 11, 2024",
    desc: "India Post News Service A formal kick off - 'Satish Chandra for Santa Clara City Council 2024 for District # 1' - at Agnews Historic...",
    link: "https://indiapost.com/american-hindu-launches-election-campaign-in-santa-clara-ca/"
  },
  {
    image: news53,
    title: "California Civil Rights Department (CRD) Penalized; Unfairly targeted Indian Americans in a caste discrimination lawsuit hoax",
    date: "June 24, 2024",
    desc: "Geeta Sikand Director of Communications - Americans4Hindus In a significant judgment for Cisco Systems and the Hindu American community, the court penalized the Civil Rights Department...",
    link: "https://indiapost.com/california-civil-rights-department-crd-penalized-unfairly-targeted-indian-americans-in-a-caste-discrimination-lawsuit-hoax/"
  },
  {
    image: news54,
    title: "Community Supports Teresa Cox for Re-Election to Fremont City Council",
    date: "June 14, 2024",
    desc: "Ritu Maheshwari India Post News Service FREMONT, CA: Dr. Romesh Japra with his wife Sunita Japra held a grand Meet-n-Greet for Teresa Cox for Re-Election to...",
    link: "https://indiapost.com/community-supports-teresa-cox-for-re-election-to-fremont-city-council/"
  },
  {
    image: news55,
    title: "Asian Heritage Festival celebrated in Fremont, CA",
    date: "May 16, 2024",
    desc: "Ritu Maheshwari India Post News Service FREMONT, CA: It was an amazing colorful celebration of Asian Heritage Festival on Sunday, May 4th at Fremont Downtown Event...",
    link: "https://indiapost.com/asian-heritage-festival-celebrated-in-fremont-ca/"
  },
  {
    image: news56,
    title: "A4H celebrates ‘Swatantrya Veer Savarkar’ movie launch to honor the Patriot",
    date: "March 28, 2024",
    desc: "Ritu Maheshwari India Post News Service Fremont, CA: It was a beautiful synthesis of patriotism, cultural awakening, Hindu values along with traditional ceremonies to inaugurate Premier...",
    link: "https://indiapost.com/a4h-celebrates-swatantrya-veer-savarkar-movie-launch-to-honor-the-patriot/"
  },
  {
    image: news57,
    title: "Another Hindu temple vandalized in California",
    date: "January 6, 2024",
    desc: "India Post News Service In Hayward, California, the Sherawali Temple on Christmas Day became the latest victim of pro-Khalistan graffiti, mirroring a similar incident at the...",
    link: "https://indiapost.com/another-hindu-temple-vandalized-in-california/"
  },
  {
    image: news58,
    title: "Hindu Temple Vandalism in Silicon Valley intimidating Community with fear of Violence and Hate Crime",
    date: "December 25, 2023",
    desc: "Shri Swaminarayan Mandir Vasna Sanstha (SMVS) Temple in Cedar Blvd, Newark, California was vandalised with anti-India graffiti on Dec 21 and the police are...",
    link: "https://indiapost.com/hindu-temple-vandalism-in-silicon-valley-intimidating-community-with-fear-of-violence-and-hate-crime/"
  },
  {
    image: news59,
    title: "Vinay Kruttiventi for Congress shares his commitment to build better communities",
    date: "December 15, 2023",
    desc: "India Post News Service FREMONT, CA: Vinay Kruttiventi, entrepreneur and community leader, is running for Congress in Alameda County’s District 14. In conversation with Ritu...",
    link: "https://indiapost.com/vinay-kruttiventi-for-congress-shares-his-commitment-to-build-better-communities/"
  },
  {
    image: news60,
    title: "City of Fremont presents Proclamation for Diwali",
    date: "November 30, 2023",
    desc: "Ritu Maheshwari India Post News Service FREMONT, CA: On Tuesday, November 7, 2023, the Proclamation for Diwali the Hindu Festival of Lights was presented by the...",
    link: "https://indiapost.com/city-of-fremont-presents-proclamation-for-diwali/"
  },
  {
    image: news61,
    title: "Fundraiser – Raj Salwan for Mayor of Fremont",
    date: "November 30, 2023",
    desc: "Lakshmi Iyer India Post News Service FREMONT, CALIFORNIA: Raj Salwan, Fremont Council member is running for the post of Mayor next year. Dr. Romesh Japra, the...",
    link: "https://indiapost.com/fundraiser-raj-salwan-for-mayor-of-fremont/"
  },
  {
    image: news62,
    title: "City of San Jose presents Proclamation for Hindu Heritage Month and Diwali",
    date: "November 3, 2023",
    desc: "Ritu Maheshwari India Post News Service San Jose, CA: On Tuesday, Oct 31, 2023, Proclamations for Hindu Heritage month and Diwali Hindu festival day were presented...",
    link: "https://indiapost.com/city-of-san-jose-presents-proclamation-for-hindu-heritage-month-and-diwali/"
  },
  {
    image: news63,
    title: "Bay Area Hindu Americans express solidarity with Israel after Hamas terror attacks",
    date: "October 20, 2023",
    desc: "FREMONT, CALIFORNIA: On Sunday afternoon, 15th October, a group of Hindu Americans gathered with Israeli and other Jewish Americans to express solidarity with them...",
    link: "https://indiapost.com/bay-area-hindu-americans-express-solidarity-with-israel-after-hamas-terror-attacks/"
  },
  {
    image: news64,
    title: "California Bill SB-403 vetoed by Governor Newsom",
    date: "October 12, 2023",
    desc: "On Saturday, October 7, California Governor Gavin Newsom vetoed SB-403, the so-called California Caste Bill. In vetoing the bill, officially called Senate Bill 403...",
    link: "https://indiapost.com/california-bill-sb-403-vetoed-by-governor-newsom/"
  },
  {
    image: news65,
    title: "Asian American Unity Coalition hosts Unity Summit in Washington",
    date: "October 6, 2023",
    desc: "India Post News Service The Asian American Unity Coalition (AAUC) recently held a historic Unity Summit in Washington, Sept. 26-27, 2023. The summit underscored the strength...",
    link: "https://indiapost.com/asian-american-unity-coalition-hosts-unity-summit-in-washington/"
  },
  {
    image: news66,
    title: "Successful Press Conference at US Capitol Hill marks the Founding of the Hindu, Buddhist, Sikh, and Jain American Congressional Caucus (HBSJ)",
    date: "September 30, 2023",
    desc: "WASHINGTON, D.C. — On Friday, September 29th, 2023, an extraordinary press conference was held at the United States Capitol Hill, heralding the birth of...",
    link: "https://indiapost.com/successful-press-conference-at-us-capitol-hill-marks-the-founding-of-the-hindu-buddhist-sikh-and-jain-american-congressional-caucus-hbsj/"
  },
  {
    image: news67,
    title: "Dr. Romesh Japra, honored with Community Service Award by the Asian American Unity Coalition at Capitol Hill",
    date: "September 28, 2023",
    desc: "WASHINGTON, DC: Dr. Romesh Japra, a distinguished cardiologist, cultural entrepreneur, publisher, community leader, and political activist, has been awarded the prestigious Community Service Award...",
    link: "https://indiapost.com/dr-romesh-japra-honored-with-community-service-award-by-the-asian-american-unity-coalition-at-capitol-hill/"
  },
  {
    image: news68,
    title: "Prominent Hindu activist Milind Makwana dies of heart attack during city council hearing in California",
    date: "July 28, 2023",
    desc: "A prominent Indian-American Hindu activist fighting against the recent caste discrimination bill in California Assembly died of a heart attack as he passionately spoke...",
    link: "https://indiapost.com/prominent-hindu-activist-milind-makwana-dies-of-heart-attack-during-city-council-hearing-in-california/"
  },
  {
    image: news69,
    title: "Hindu, Buddhist and Sikh American Congressional Caucus officially registered",
    date: "June 30, 2023",
    desc: "Hindu, Buddhist and Sikh American Congressional Caucus has been officially registered! On behalf of Americans4Hindus and 20 partner organizations, we would like to congratulate all...",
    link: "https://indiapost.com/hindu-buddhist-and-sikh-american-congressional-caucus-officially-registered/"
  },
  {
    image: news70,
    title: "HINDU CAUCUS FORMED: First-ever Hindu Caucus in US Congress",
    date: "June 23, 2023",
    desc: "The first-ever Hindu-American Summit was organized on Wednesday June 14 at Capitol Hill, the seat of the US government, where several Congressional leaders and...",
    link: "https://indiapost.com/hindu-caucus-formed-first-ever-hindu-caucus-in-us-congress/"
  },
  {
    image: news71,
    title: "Shri Thanedar – from Belgaum, India to the US House of Representatives",
    date: "June 16, 2023",
    desc: "A fundraiser for the political super PAC, Americans4Hindus (A4H), was held on Sunday, June 4th, at Japra Mahal in Fremont, California. This PAC (Political Action...",
    link: "https://indiapost.com/shri-thanedar-from-belgaum-india-to-the-us-house-of-representatives/"
  },
  {
    image: news72,
    title: "Mayor of Santa Clara Lisa Gillmor receives Americans For Hindus Endorsement",
    date: "October 7, 2022",
    desc: "India Post News Service SANTA CLARA, CA: Americans for Hindus endorsed her for her Mayoral Re-Election campaign. This honor was announced at the Americans for...",
    link: "https://indiapost.com/mayor-of-santa-clara-lisa-gillmor-receives-americans-for-hindus-endorsement/"
  },
  {
    image: news73,
    title: "Most Indo-Americans weigh behind Mayor Lily Mei for State Senate",
    date: "May 26, 2022",
    desc: "India Post News Service California voters have the brand new districts they’ll use to elect their members of Congress and state legislators, after the state’s...",
    link: "https://indiapost.com/most-indo-americans-weigh-behind-mayor-lily-mei-for-state-senate/"
  },
  {
    image: news74,
    title: "NRIs support Tikshan Sood, BJP for upcoming assembly election",
    date: "February 11, 2022",
    desc: "India Post News Service Tikshan Sood is a member of the Bharatiya Janata Party. He will contest the upcoming Punjab Assembly elections from Hoshiarpur. He...",
    link: "https://indiapost.com/nris-support-tikshan-sood-bjp-for-upcoming-assembly-election/"
  },
  {
    image: news75,
    title: "1 in 2 Indian-Americans discriminated in past year: Study",
    date: "June 10, 2021",
    desc: "WASHINGTON: A new study has revealed that one in two Indian-Americans have reported being discriminated against in the past one year. The study titled, 'Social...",
    link: "https://indiapost.com/1-in-2-indian-americans-discriminated-in-past-year-study/"
  },
  {
    image: news76,
    title: "Dr Sampat Shivangi on Coalition Advisory Board, Donald J. Trump for President, Inc. (the “Campaign”)",
    date: "August 6, 2020",
    desc: "India Post News Service Dr. Sampat Shivangi, a physician, an influential Indian-American community leader, and a veteran leader of the American Association of Physicians of...",
    link: "https://indiapost.com/dr-sampat-shivangi-on-coalition-advisory-board-donald-j-trump-for-president-inc-the-campaign/"
  },
  {
    image: news77,
    title: "Over 100,000 Indian-Americans watch virtual rally",
    date: "July 23, 2020",
    desc: "Aditya Satsangi & IPNS FREMONT: Hindus4Trump held a massive virtual rally on 19th July across the 48 states of the United States. The rally was...",
    link: "https://indiapost.com/over-100000-indian-americans-watch-virtual-rally/"
  }
  ];

  // PAGINATION LOGIC

  const totalPages = Math.ceil(newsData.length / reportsPerPage);

  const startIndex = (currentPage - 1) * reportsPerPage;

  const currentReports = newsData.slice(
    startIndex,
    startIndex + reportsPerPage
  );

  return (
    <>
      <style>{`
        .press-section{
          background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
          padding:140px 0 80px;
        }

        .press-title{
          text-align:center;
          font-size:48px;
          font-weight:900;
          color:#0c0505ff;
          margin-bottom:20px;
          margin-top:-40px;
        }

        .press-divider{
          width:180px;
          height:4px;
          margin:0 auto 70px;
          background:linear-gradient(
            to right,
            transparent,
            #0c0505ff,
            #ff8a00,
            #0a0707ff,
            transparent
          );
          border-radius:50px;
          position:relative;
        }

        .press-divider::before{
          content:"";
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50%, -50%);
          width:18px;
          height:18px;
          background:#fff;
          border:4px solid #ff8a00;
          border-radius:50%;
          box-shadow:0 0 12px rgba(255,138,0,0.5);
        }

        .news-wrapper{
          display:flex;
          flex-direction:column;
          gap:48px;
        }

        .news-card{
          display:flex;
          align-items:flex-start;
          gap:28px;
        }

        .news-image{
          width:190px;
          height:190px;
          object-fit:cover;
          flex-shrink:0;
        }

        .news-content{
          flex:1;
        }

        .news-title{
          font-size:28px;
          line-height:1.3;
          font-weight:500;
          color:#222;
          margin-bottom:10px;
          cursor:pointer;
          transition:0.3s;
        }

        .news-title:hover{
          color:#2d9bf0;
        }

        .news-date{
          font-size:18px;
          color:#000;
          margin-bottom:18px;
        }

        .news-desc{
          font-size:18px;
          line-height:1.7;
          color:#000;
        }

        .news-link{
          text-decoration:none;
        }

        /* PAGINATION */

        .pagination{
          display:flex;
          justify-content:center;
          align-items:center;
          gap:12px;
          margin-top:70px;
          flex-wrap:wrap;
        }

        .page-btn{
          width:45px;
          height:45px;
          border:1px solid #ccc;
          background:#fff;
          cursor:pointer;
          font-size:18px;
          transition:0.3s;
        }

        .page-btn:hover{
          background:#2d9bf0;
          color:#ff8a00;
          border-color:#2d9bf0;
        }

        .page-btn.active{
          background:#2d9bf0;
          color:#fff;
          border-color:#2d9bf0;
        }
        .news-image-frame{
  position: relative;
  display: inline-block;
  padding: 8px;
  border-radius: 28px;
  overflow: hidden;

  background: linear-gradient(
    145deg,
    rgba(255,255,255,0.18),
    rgba(255,255,255,0.05)
  );

  backdrop-filter: blur(14px);

  box-shadow:
    0 12px 35px rgba(0,0,0,0.35),
    inset 0 1px 1px rgba(255,255,255,0.2);

  transition:
    transform .5s ease,
    box-shadow .5s ease;
}

/* Rotating border */
.news-image-frame::before{
  content:"";
  position:absolute;
  width:220%;
  height:220%;
  top:-60%;
  left:-60%;

  background: conic-gradient(
    from 0deg,
    #ffcc00,
    #ffffff,
    #ff7b00,
    #ffd700,
    #fff6b0,
    #ffcc00
  );

  animation: rotateFrame 7s linear infinite;
}

/* Inner overlay */
.news-image-frame::after{
  content:"";
  position:absolute;
  inset:4px;
  border-radius:24px;

  background: rgba(0,0,0,0.12);

  z-index:1;
}

/* Image */
.news-image{
  position: relative;
  z-index: 2;

  width: 190px;
  height: 190px;
  object-fit: cover;

  border-radius: 20px;

  border: 2px solid rgba(255,255,255,0.18);

  transition:
    transform .5s ease,
    filter .5s ease;
}

/* Shine */
.news-shine{
  position:absolute;
  top:0;
  left:-120%;
  width:50%;
  height:100%;

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.35),
    transparent
  );

  transform: skewX(-25deg);

  z-index:3;

  animation: shineMove 5s infinite;
}

/* Hover */


/* Animations */
@keyframes rotateFrame{
  100%{
    transform: rotate(360deg);
  }
}

@keyframes shineMove{
  0%{
    left:-120%;
  }
  50%{
    left:140%;
  }
  100%{
    left:140%;
  }
}
       @media (max-width: 768px) {
        
  .press-section{
    padding:100px 0 40px;
  }

  .press-title{
    font-size:32px;
    margin-bottom:15px;
  }

  .press-divider{
    margin:0 auto 35px;
  }

  .news-wrapper{
    gap:28px;
  }

  .news-card{
    display:flex;
    flex-direction:row !important;
    align-items:flex-start;
    gap:16px;
  }

  .news-image-frame{
    width:90px;
    min-width:90px;
    padding:0;
    border-radius:0;
    background:none;
    backdrop-filter:none;
    box-shadow:none;
  }

  .news-image-frame::before,
  .news-image-frame::after,
  .news-shine{
    display:none;
  }

  .news-image{
    width:90px !important;
    height:90px !important;
    border-radius:0;
    border:none;
    object-fit:cover;
  }

  .news-content{
    flex:1;
  }

  .news-title{
    font-size:18px;
    line-height:1.25;
    font-weight:500;
    margin-bottom:8px;
  }

  .news-date{
    font-size:14px;
    color:#888;
    margin-bottom:0;
  }

  /* Hide description on mobile like screenshot */
  .news-desc{
    display:none;
  }

  .pagination{
    margin-top:40px;
    gap:8px;
  }

  .page-btn{
    width:38px;
    height:38px;
    font-size:15px;
  }
  
  
}
      `}</style>

      <div className="press-section">
        <div className="container">

          <h1 className="press-title">
            A4H PRESS RELEASES
          </h1>

          <div className="press-divider"></div>

          <div className="news-wrapper">

            {currentReports.map((item, index) => (
              <div className="news-card" key={index}>

                <div className="news-image-frame">
                  <span className="news-shine"></span>

                  <img
                    src={item.image}
                    alt={item.title}
                    className="news-image"
                  />
                </div>

                <div className="news-content">

                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="news-link"
                  >
                    <h2 className="news-title">
                      {item.title}
                    </h2>
                  </a>

                  <div className="news-date">
                    {item.date}
                  </div>

                  <div className="news-desc">
                    {item.desc}
                  </div>

                </div>

              </div>
            ))}

          </div>

          {/* PAGINATION */}

         <div className="pagination">

  {/* PREV BUTTON */}
  {currentPage > 1 && (
    <button
      className="page-btn"
      onClick={() => setCurrentPage(currentPage - 1)}
    >
      &lt;
    </button>
  )}

  {/* FIRST PAGE */}
  <button
    className={`page-btn ${currentPage === 1 ? "active" : ""}`}
    onClick={() => setCurrentPage(1)}
  >
    1
  </button>

  {/* LEFT DOTS */}
  {currentPage > 3 && <span>...</span>}

  {/* MIDDLE PAGES */}
  {[currentPage - 1, currentPage, currentPage + 1].map((page) => {
    if (page > 1 && page < totalPages) {
      return (
        <button
          key={page}
          className={`page-btn ${currentPage === page ? "active" : ""}`}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </button>
      );
    }
    return null;
  })}

  {/* RIGHT DOTS */}
  {currentPage < totalPages - 2 && <span>...</span>}

  {/* LAST PAGE */}
  {totalPages > 1 && (
    <button
      className={`page-btn ${currentPage === totalPages ? "active" : ""}`}
      onClick={() => setCurrentPage(totalPages)}
    >
      {totalPages}
    </button>
  )}

  {/* NEXT BUTTON */}
  {currentPage < totalPages && (
    <button
      className="page-btn"
      onClick={() => setCurrentPage(currentPage + 1)}
    >
      &gt;
    </button>
  )}

  {/* PAGE TEXT */}
  <div style={{ marginLeft: "20px" }}>
    Page {currentPage} of {totalPages}
  </div>

</div>

        </div>
      </div>
    </>
  );
}

export default PressReleasesPage;